import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {InlineBannerType} from 'ui-library/banners/InlineBanner';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {BANNER_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const RUN_SCIENTIFIC_MODEL_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.RUN_SCIENTIFIC_MODEL,
  0
> = {
  [BANNER_KEY]: {
    text: 'This step runs a scientific model for each input row.',
    bannerType: InlineBannerType.INFO,
  },
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['predictionBatchFolderId', 'modelConfig'],
  predictionBatchFolderId: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['predictionBatchFolderId'],
    predictionBatchFolderId: {
      displayName: 'Prediction batch folder',
      configShapePath: ['predictionBatchFolderId'],
    },
  },
  modelConfig: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['modelConfig'],
    modelConfig: {
      displayName: 'Scientific model',
      configShapePath: ['modelConfig'],
      fieldSettings: {
        tagKeyDisplayName: 'Model',
        tagKeyDisplayNames: {
          deepsp: 'DeepSP',
          'tunelab:ablab': 'Lilly TuneLab: AbLab',
        },
        choiceFieldOrder: ['heavyChainColumn', 'lightChainColumn'],
        choiceUISchema: {
          heavyChainColumn: {
            displayName: 'Heavy-chain sequence column',
            configShapePath: ['heavyChainColumn'],
          },
          lightChainColumn: {
            displayName: 'Light-chain sequence column',
            configShapePath: ['lightChainColumn'],
          },
        },
      },
    },
  },
};
